<template>
    <div class="center-page">
        <div class="page-head">
            <el-form inline label-width="120px" label-position="left">
                <el-form-item label="选择所在地">
                    <el-select v-model="searchForm.text">
                        <el-option v-for="item in cityList" :key="item.id" :value="item.name"
                                   :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item style="margin-top: 40px;">
                    <el-button type="primary" @click="handlerSearch">搜索</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="order-body" v-loading="loading">
            <div class="order-item" v-for="(item,index) in list" :key="index">
                <div class="order-title">{{item.state|parseType}}服务</div>
                <div class="order-content">
                    <el-form class="order-body-form" label-width="120px" label-position="right">
                        <el-row>
                            <el-col :span="8">
                                <el-form-item style="margin-bottom: 0;" label="机场：">{{item.airport}}</el-form-item>
                                <el-form-item v-if="item.flight" style="margin-bottom: 0;" label="航班号：">
                                    {{item.flight}}
                                </el-form-item>
                                <el-form-item style="margin-bottom: 0;" label="到达终点：">{{item.address}}</el-form-item>
                                <el-form-item v-if="item.state===1" style="margin-bottom: 0;" label="接机时间：">
                                    {{item.reception_time}}
                                </el-form-item>
                                <el-form-item v-else style="margin-bottom: 0;" label="送机时间：">
                                    {{item.reception_time}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item style="margin-bottom: 0;" label="人数：">{{item.people}}人</el-form-item>
                                <el-form-item style="margin-bottom: 0;" label="行李：">{{item.bags}}件</el-form-item>
                                <el-form-item v-if="item.state===2" style="margin-bottom: 0;" label="是否协办登机：">
                                    {{item.is_help===1?'是':'否'}}
                                </el-form-item>
                                <el-form-item style="margin-bottom: 0;" label="留言备注：">
                                    <div class="line-clamp-1" :title="item.remark">{{item.remark}}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item style="margin-bottom: 0;" label="联系人：">{{item.contact}}人</el-form-item>
                                <el-form-item style="margin-bottom: 0;" label="联系电话：">{{item.telphone}}件</el-form-item>
                                <el-form-item style="margin-bottom: 0; margin-top: 20px;">
                                    <el-button type="primary" @click="driverCarRush(item.id)">抢单</el-button>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </div>
            <el-alert v-if="list.length<=0" title="暂无数据~" center :closable="false" type="warning" show-icon></el-alert>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: "robOrder",
        data() {
            return {
                loading: false,
                searchForm: {
                    text: '',
                    page: 1
                },
                list: []
            }
        },
        computed: {
            ...mapState(['cityList'])
        },
        created() {
            this.searchForm.text = this.cityList[0].name;
            this.getOrder()
        },
        methods: {
            async getOrder() {
                this.loading = true;
                let [e, data] = await this.$api.carSingleApi(this.searchForm);
                this.loading = false;
                if (data.code === 200) {
                    this.list = data.result.data
                }
            },
            handlerSearch() {
                this.searchForm.page = 1;
                this.getOrder()
            },
            async driverCarRush(transfer_id) {
                try {
                    let {value} = await this.$prompt('请输入每位乘客的单价（将自当按需求人数给予用户总价）', '抢单价格输入', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        inputPlaceholder: '金额设定',
                        closeOnClickModal: false,
                        inputValidator(item) {
                            let reg = /^\d+(\.\d+)?$/;
                            return reg.test(item) && item > 0
                        },
                        inputErrorMessage: '请输入正确金额！'
                    })
                    let [err, data] = await this.$api.driverCarRushApi({
                        transfer_id, price: value
                    })
                    if(data.status){
                        this.$message.success('抢单成功！')
                        this.getOrder()
                    }else {
                        this.$message.warning(data.msg)
                    }
                } catch (e) {

                }
            }
        },
        filters: {
            parseType(data) {
                switch (data) {
                    case 1:
                        return '接机';
                    case 2:
                        return '送机'
                    default:
                        return '接送机'
                }
            }
        }
    }
</script>

<style scoped lang="less">
    .page-head {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        border-bottom: 1px solid #e2e2e2;
    }

    .order-body {
        margin-top: 20px;

        .order-item {
            border-radius: 6px;
            overflow: hidden;
            margin-bottom: 20px;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
            padding: 20px;
            box-sizing: border-box;
        }

        .order-title {
            font-weight: bold;
            margin-bottom: 10px;
        }

        .order-content {
            display: flex;
            justify-content: flex-start;
            align-items: center;
        }

        .order-body-form {
            flex: 1;
        }

        .order-body-btn {
            width: 200px;
        }
    }
</style>
